// extracted by mini-css-extract-plugin
module.exports = {"learning_content":"learning__learning_content___2B-Zr","flex_box":"learning__flex_box___1RSHw","img_wrapper":"learning__img_wrapper___vwwxr"};